import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionsComponent } from './subscriptions.component';
import { SharedModule } from '../../shared/shared.module';
import { DsrIconsModule } from '@desyre/icons-angular';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        SubscriptionsComponent
    ], 
    imports: [
        CommonModule,
        SharedModule,
        DsrIconsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TranslateModule,
        MatButtonToggleModule,
        FormsModule,
        MatTableModule,
        MatChipsModule,
        MatTooltipModule
    ], 
    providers: [provideHttpClient(withInterceptorsFromDi())]
})

export class SubscriptionsModule { }